import { ApiService } from './api/sprint7plus';

export const apiService = new ApiService();
